const URL = '/cuentas';

const state = {
  all: [],
  selected: {
    id: null,
    numero: null,
    descripcion: null,
    cierre: null,
    kilos_pleno: 0,
    saldo_usuario: 0,
    saldo_subsidio: 0,
    saldo_pleno: 0,
    credito_demas: 0,
    cliente_id: null,
    sucursal_id: null,
    created_at: null,
    updated_at: null
  },
  edited: {
    id: null,
    numero: null,
    descripcion: null,
    cierre: null,
    kilos_pleno: 0,
    saldo_usuario: 0,
    saldo_subsidio: 0,
    saldo_pleno: 0,
    credito_demas: 0,
    cliente_id: null,
    sucursal_id: null,
    created_at: null,
    updated_at: null
  },
  filters: {
    numero: null,
    descripcion: null,
    cierre_from: null,
    cierre_to: null,
    cliente_id: null,
    solo_cerradas: true
  },
  loading: false,
  headers: [
    {
      text: 'Número',
      value: 'numero',
      align: 'center'
    },
    {
      text: 'Descripcion',
      value: 'descripcion',
      align: 'center'
    },
    {
      text: 'Saldo $ subsidiado',
      value: 'saldo_usuario',
      align: 'center'
    },
    {
      text: 'Saldo $ sin subsidio',
      value: 'saldo_pleno',
      align: 'center'
    },
    {
      text: 'Saldo total',
      value: 'id',
      align: 'center'
    },
  ],
  rules: {
    numero: [
      v => !!v || 'Este campo es necesario',
    ],
    descripcion: [
      // v => !!v || 'Este campo es necesario',
    ],
    saldo_usuario: [
      // v => !!v || 'Este campo es necesario',
    ],
    cierre: [
      // v => !!v || 'Este campo es necesario',
    ],
    cliente_id: [
      v => !!v || 'Este campo es necesario',
      v => v > 0 || 'Debe existir un cliente asociado',
    ],
  },
  options: {
    page: 1,
    itemsPerPage: 10,
    sortBy: [],
    sortDesc: []
  },
  itemsLength: null,
}

// GETTERS
const getters = {
  all (state) {
    return state.all
  },
  edited (state) {
    return state.edited
  },
  selected (state) {
    return state.selected
  },
  filters (state) {
    return state.filters
  },
  rules (state) {
    return state.rules
  },
  headers (state) {
    return state.headers
  },
  itemsLength (state) {
    return state.itemsLength
  },
  options (state) {
    return state.options
  },
  loading (state) {
    return state.loading
  },
}

// ACTIONS
const actions = {
  onClearAll ({ commit }) {
    commit('setAll', [])
    commit('setOptions', {
      page: 1,
      itemsPerPage: 10,
      sortBy: [],
      sortDesc: []
    })
    commit('setItemsLength', null)
  },
  onClearEdited ({ commit}) {
    commit('setEdited', {
      id: null,
      numero: null,
      descripcion: null,
      kilos_pleno: null,
      saldo_usuario: null,
      saldo_subsidio: null,
      cierre: null,
      cliente_id: null,
      sucursal_id: null,
      created_at: null,
      updated_at: null
    })
  },
  onClearSelected ({ commit}) {
    commit('setSelected', {
      id: null,
      numero: null,
      descripcion: null,
      kilos_pleno: null,
      saldo_usuario: null,
      saldo_subsidio: null,
      cierre: null,
      cliente_id: null,
      sucursal_id: null,
      created_at: null,
      updated_at: null
    })
  },
  onFetch ({ state, commit }) {
    const cerradas = 1;
    return new Promise((resolve, reject) => {
      commit('setLoading', true)
      axios.get(URL, {
        params: {
          itemsPerPage: state.options.itemsPerPage,
          page: state.options.page,
          sortBy: state.options.sortBy[0],
          sortDesc: state.options.sortDesc[0] ? 1 : 0,
          cliente_id: state.filters.cliente_id,
          cerradas: cerradas,
        }
      })
        .then(response => {
          commit('setAll', response.data.data)
          commit('setItemsLength', response.data.meta.total)
          if (state.options.page + state.options.itemsPerPage > response.data.meta.total)
            commit('setPage', 1)
          resolve(response.data)
        })
        .catch(error => {
          reject(error)
        })
        .finally(() => {
          commit('setLoading', false)
        })
    })
  },
}

// MUTATIONS
const mutations = {
  setAll (state, payload) {
    state.all = payload.slice()
  },
  setEdited (state, payload) {
    state.edited = Object.assign({}, payload)
  },
  setSelected (state, payload) {
    state.selected = Object.assign({}, payload)
  },
  setFilters (state, payload) {
    state.filters = Object.assign({}, payload)
  },
  setLoading (state, payload) {
    state.loading = payload
  },
  setPage (state, payload) {
    state.options.page = payload
  },
  setItemsPerPage (state, payload) {
    state.options.itemsPerPage = payload
  },
  setItemsLength (state, payload) {
    state.itemsLength = payload
  },
  setOptions (state, payload) {
    state.options = payload
  },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
